import React, { Suspense, lazy } from 'react';
import SignInFirst from './SignInFirst';
import { hasModule } from '../../hooks/useModuleAccess';
import { useOrganization } from '../../../features/organization/OrganizationContext';

const ForbiddenPage = lazy(() => import('../../../features/errors/pages/ForbiddenPage'));

/**
 * `allowTrainerBypass`: for a single workshop session's own pages (Dashboard,
 * Present, Board), skip the blanket per-user module check here even if the
 * org restricts "workshops" to specific users -- a session's confirmed
 * trainer (RSVP-approved speaker on the linked event) still needs to reach
 * THAT session regardless, mirroring ModuleAccessFilter.isTrainerForRequestPath
 * on the backend, which is the real authority: it 403s the actual API calls
 * for anyone who is neither module-enabled nor that session's trainer, and
 * this route lets the page load far enough to hit that check and show its
 * own error/EmptyState. The org-level toggle below still fully gates --
 * skipping it would let a session bypass "workshops" being off for the
 * whole org, which no trainer grant should override.
 */
export default function ModuleRoute({ user, moduleKey, children, requireAuth = false, allowTrainerBypass = false }: any) {
  const { orgEnabledModules } = useOrganization();

  if (requireAuth && !user) {
    return <SignInFirst />;
  }

  if (user && orgEnabledModules !== null && !orgEnabledModules.includes(moduleKey)) {
    return (
      <Suspense fallback={null}>
        <ForbiddenPage />
      </Suspense>
    );
  }

  if (user && !allowTrainerBypass && !hasModule(user, moduleKey)) {
    return (
      <Suspense fallback={null}>
        <ForbiddenPage />
      </Suspense>
    );
  }

  return children;
}
